import { Component, OnInit } from '@angular/core';
import {PurchaseOrderSummaryModel} from '../../entity/purchaseOrderSummary.model';
import {IDialogComponent} from '../../../../../../common/dialog/iDialog.component';
import {DialogWithInput} from '../../../../../../common/dialog/dialogWithInput';
import {
  SaleInvoiceConfigurationFindOneByAccountBusinessCodeService
} from '../../../../invoice/modules/configuration/impl/service/saleInvoiceConfigurationFindOneByAccountBusinessCode.service';
import {
  SaleInvoiceConfigurationModel
} from '../../../../invoice/modules/configuration/api/entity/saleInvoiceConfiguration.model';
import {FormBuilder, FormGroup} from '@angular/forms';
import {PurchaseOrderSendByEmailActionService} from '../../../impl/service/purchaseOrderSendByEmailAction.service';
import {ToastControl} from '../../../../../../../controls/core/toast/toast.control';
import {
  PurchaseOrderFormatContentActionService, PurchaseOrderFormatContentPayload,
} from "../../service/purchaseOrderFormatContentAction.service";
import {MomentAdapter} from "../../../../../../../shared/utils/moment.utils";

export interface PurchaseOrderSendByEmailInput {
  purchaseOrderSummary: PurchaseOrderSummaryModel;
  toEmail: string;
}

export interface PurchaseOrderSendByEmailResult {
  entity: PurchaseOrderSummaryModel;
}

@Component({
  templateUrl: './purchase-order-send-by-email.component.html',
  providers: [
    SaleInvoiceConfigurationFindOneByAccountBusinessCodeService,
    PurchaseOrderSendByEmailActionService,
    PurchaseOrderFormatContentActionService,
  ]
})
export class PurchaseOrderSendByEmailComponent implements
    IDialogComponent<PurchaseOrderSendByEmailInput, PurchaseOrderSendByEmailResult>, OnInit {
  dialog: DialogWithInput<PurchaseOrderSendByEmailInput, PurchaseOrderSendByEmailResult>;

  configuration: SaleInvoiceConfigurationModel;

  initialTo: string;
  initialSubject: string;
  initialContent: string;

  formGroup: FormGroup;

  constructor(public configurationService: SaleInvoiceConfigurationFindOneByAccountBusinessCodeService,
              public sendEmailService: PurchaseOrderSendByEmailActionService,
              private formBuilder: FormBuilder,
              private toastControl: ToastControl,
              public formatContentActionService: PurchaseOrderFormatContentActionService) {
    this.formGroup = this.formBuilder.group({});
  }

  ngOnInit(): void {
    this.initialTo = this.dialog.input.toEmail;
  }

  configurationLoaded(entity: SaleInvoiceConfigurationModel) {
    this.configuration = entity;
    this.initialContent = this.formatContent(entity?.purchaseOrderEmailConfiguration?.content);
    this.initialSubject = this.formatContent(entity?.purchaseOrderEmailConfiguration?.subject);
  }

  private formatContent(content: string): string {
    if (!content) {
      return content;
    }
    return content
        .replace('La facture', 'Le devis')
        .replace('la facture', 'le devis')
        .replace('Facture', 'Devis')
        .replace('Devis', 'devis');
  }

  send() {
    this.sendEmailService.executeAction({
      id: this.dialog.input.purchaseOrderSummary.id,
      emailContent: this.formGroup.value
    }).then((value) => {
      this.dialog.close({
        entity: value
      });
      this.toastControl.presentConfirmation('L\'e-mail a été envoyé');
    });
  }

  buildFormatContentPayload = (): PurchaseOrderFormatContentPayload => {
    return {
      report: {
        partnerId: this.dialog.input.purchaseOrderSummary?.partnerId,
        content: undefined,
        date: MomentAdapter.current().get()
      },
      id: this.dialog.input.purchaseOrderSummary.id
    };
  }
}
